import { Route } from '@angular/router';
import { initialDataResolver } from 'app/app.resolvers';
import { AuthGuard } from 'app/core/auth/guards/auth.guard';
import { NoAuthGuard } from 'app/core/auth/guards/noAuth.guard';
import { LayoutComponent } from 'app/layout/layout.component';


export const appRoutes: Route[] = [

    // Redirect empty path to '/example'
    { path: '', pathMatch: 'full', redirectTo: 'home' },
    { path: 'signed-in-redirect', pathMatch: 'full', redirectTo: 'home' },

    {
        path: '', canActivate: [NoAuthGuard], canActivateChild: [NoAuthGuard],
        component: LayoutComponent, data: { layout: 'empty' },
        children: [{ path: 'sign-in', loadChildren: () => import('app/module-auth/modules/sign-in/sign-in.routes') },
        ]
    },
    {
        path: '', canActivate: [AuthGuard], canActivateChild: [AuthGuard],
        component: LayoutComponent, data: { layout: 'empty' },
        children: [{ path: 'sign-out', loadChildren: () => import('app/module-auth/modules/sign-out/sign-out.routes') },]
    },
    {
        path: '',
        canActivate: [AuthGuard],
        canActivateChild: [AuthGuard],
        component: LayoutComponent,
        resolve: {
            initialData: initialDataResolver
        },
        children: [
            //{ path: 'home', loadChildren: () => import('app/module-auth/modules/home/home.routes') },
            { path: 'home', loadChildren: () => import('app/module-file/modules/dashboard/dashboard.routes') },
            { path: 'account', loadChildren: () => import('app/module-auth/modules/account/account.routes') },
        ]
    },
    {
        path: '',
        component: LayoutComponent,
        resolve: {
            initialData: initialDataResolver
        },
        children: [
            { path: 'security/admin', loadChildren: () => import('app/module-auth/modules/rol/rol.routes') },
            { path: 'security/admin', loadChildren: () => import('app/module-auth/modules/user/user.routes') },
        ]
    },

    {
        path: '',
        component: LayoutComponent,
        resolve: {
            initialData: initialDataResolver
        },
        children: [

            { path: 'sales/master', loadChildren: () => import('app/module-file/modules/parameter/dealership/dealership.routes') },
            { path: 'sales/master', loadChildren: () => import('app/module-file/modules/parameter/sales-channels/sales-channels.routes') },
            { path: 'sales/master', loadChildren: () => import('app/module-file/modules/parameter/vehicles/vehicles.routes') },
            { path: 'sales/master', loadChildren: () => import('app/module-file/modules/parameter/pack/pack.routes') },
            { path: 'sales/master', loadChildren: () => import('app/module-file/modules/parameter/tasks/tasks.routes') },
            { path: 'sales/master', loadChildren: () => import('app/module-file/modules/parameter/contact/contact.routes') },
            { path: 'sales/master', loadChildren: () => import('app/module-file/modules/parameter/template/template.routes') },
            { path: 'sales/master', loadChildren: () => import('app/module-file/modules/parameter/families/families.routes') },
        ]
    },
    {
        path: '',
        component: LayoutComponent,
        resolve: {
            initialData: initialDataResolver
        },
        children: [
            { path: 'sales/process', loadChildren: () => import('app/module-file/modules/processes/process-delivery/process-deliveries.routes') },
            { path: 'sales/process', loadChildren: () => import('app/module-file/modules/processes/process-facturation/process-facturations.routes') },
            { path: 'sales/process', loadChildren: () => import('app/module-file/modules/processes/settlement-pack/settlement-pack.routes') },
            //{ path: 'sales/process', loadChildren: () => import('app/module-file/modules/processes/process-registration/process-registrations.routes') },
            { path: 'sales/process', loadChildren: () => import('app/module-file/modules/processes/process-warranty/process-warranties.routes') },
            { path: 'sales/process', loadChildren: () => import('app/module-file/modules/processes/release-vehicle/release-vehicles.routes') },
            { path: 'sales/process', loadChildren: () => import('app/module-file/modules/report/report-general/report-general.routes') },
        ]
    },
    {
        path: '',
        component: LayoutComponent,
        resolve: {
            initialData: initialDataResolver
        },
        children: [
            { path: 'sales/report', loadChildren: () => import('app/module-file/modules/report/report-general/report-general.routes') },
            { path: 'sales/report', loadChildren: () => import('app/module-file/modules/report/report-delivery/report-delivery.routes') },
            { path: 'sales/report', loadChildren: () => import('app/module-file/modules/report/report-billing/report-billing.routes') },
            { path: 'sales/report', loadChildren: () => import('app/module-file/modules/report/report-registration/process-registrations.routes') },
            { path: 'sales/report', loadChildren: () => import('app/module-file/modules/report/report-settlement/report-settlement.routes') },

        ]
    },
      {
        path: '',
        component: LayoutComponent,
        resolve: {
            initialData: initialDataResolver
        },
        children: [
            { path: 'savec/hojanegocio', loadChildren: () => import('app/module-savec/modules/business-upload/business-upload.routes') },
                  ]
    }


];
